/* tslint:disable */
/* eslint-disable */
/**
 * SONeu.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DutyScheduleAssignmentChangeRequest
 */
export interface DutyScheduleAssignmentChangeRequest {
    /**
     * 
     * @type {Date}
     * @memberof DutyScheduleAssignmentChangeRequest
     */
    date: Date;
    /**
     * 
     * @type {string}
     * @memberof DutyScheduleAssignmentChangeRequest
     */
    columnId: string;
    /**
     * 
     * @type {string}
     * @memberof DutyScheduleAssignmentChangeRequest
     */
    counselorId: string | null;
}

/**
 * Check if a given object implements the DutyScheduleAssignmentChangeRequest interface.
 */
export function instanceOfDutyScheduleAssignmentChangeRequest(value: object): value is DutyScheduleAssignmentChangeRequest {
    if (!('date' in value) || value['date'] === undefined) return false;
    if (!('columnId' in value) || value['columnId'] === undefined) return false;
    if (!('counselorId' in value) || value['counselorId'] === undefined) return false;
    return true;
}

export function DutyScheduleAssignmentChangeRequestFromJSON(json: any): DutyScheduleAssignmentChangeRequest {
    return DutyScheduleAssignmentChangeRequestFromJSONTyped(json, false);
}

export function DutyScheduleAssignmentChangeRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): DutyScheduleAssignmentChangeRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'date': (new Date(json['date'])),
        'columnId': json['columnId'],
        'counselorId': json['counselorId'],
    };
}

export function DutyScheduleAssignmentChangeRequestToJSON(json: any): DutyScheduleAssignmentChangeRequest {
    return DutyScheduleAssignmentChangeRequestToJSONTyped(json, false);
}

export function DutyScheduleAssignmentChangeRequestToJSONTyped(value?: DutyScheduleAssignmentChangeRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'date': `${value['date'].getFullYear()}-${String(value['date'].getMonth()+1).padStart(2,'0')}-${String(value['date'].getDate()).padStart(2,'0')}`,
        'columnId': value['columnId'],
        'counselorId': value['counselorId'],
    };
}

